import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiArrowRight } from 'react-icons/fi';
import api from '../services/api';

const Locations = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const data = await api.getLocations();
        setLocations(data);
      } catch (error) {
        console.error('Error fetching locations:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchLocations();
  }, []);

  const styles = {
    header: {
      background: 'linear-gradient(rgba(26,58,92,0.7), rgba(26,58,92,0.8)), url("/images/locations-hero.jpg") center/cover',
      padding: '80px 24px',
      textAlign: 'center',
      color: 'white'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '16px',
      color: 'white',
      textShadow: '0 2px 4px rgba(0,0,0,0.3)'
    },
    subtitle: {
      fontSize: '1.125rem',
      color: 'white',
      maxWidth: '600px',
      margin: '0 auto',
      textShadow: '0 1px 2px rgba(0,0,0,0.2)'
    },
    container: {
      maxWidth: '1280px',
      margin: '0 auto',
      padding: '60px 24px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '24px'
    },
    card: {
      borderRadius: '16px',
      overflow: 'hidden',
      background: 'white',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      textDecoration: 'none',
      color: 'inherit'
    },
    cardImage: {
      width: '100%',
      height: '200px',
      objectFit: 'cover'
    },
    cardContent: {
      padding: '20px'
    },
    cardTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    cardDescription: {
      color: '#555',
      marginBottom: '16px',
      lineHeight: '1.6',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    cardFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    apartmentCount: {
      color: '#555',
      fontSize: '0.875rem'
    },
    viewLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      color: '#1a3a5c',
      fontWeight: '500'
    }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>Our Locations</h1>
        <p style={styles.subtitle}>
          Discover our premium serviced apartments across the UK's most desirable destinations
        </p>
      </header>

      <section style={styles.container}>
        {loading ? (
          <div className="loading-container">
            <div className="spinner" />
          </div>
        ) : (
          <div style={styles.grid}>
            {locations.map(location => (
              <Link
                key={location._id}
                to={`/locations/${location.slug}`}
                style={styles.card}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                }}
              >
                <img
                  src={location.image || '/images/placeholder-location.jpg'}
                  alt={location.name}
                  style={styles.cardImage}
                />
                <div style={styles.cardContent}>
                  <h2 style={styles.cardTitle}>
                    <FiMapPin style={{ color: '#1a3a5c' }} />
                    {location.name}
                  </h2>
                  <p style={styles.cardDescription}>
                    {location.description || `Discover our collection of serviced apartments in ${location.name}.`}
                  </p>
                  <div style={styles.cardFooter}>
                    <span style={styles.apartmentCount}>
                      {location.apartmentCount} apartment{location.apartmentCount !== 1 ? 's' : ''}
                    </span>
                    <span style={styles.viewLink}>
                      View apartments <FiArrowRight />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default Locations;
